import { Component } from '@angular/core';


@Component({
	selector: 'devo-pipeline-tab-2-part',
	standalone: true,
	templateUrl: './devo-pipeline-tab-2.part.html',
	styleUrls: [`./devo-pipeline-tab-2.part.scss`],
})
export class DevoPipelineTab2Part {
}
